import React, { Component } from 'react';
import './UploadButton.scss';
import { Upload } from 'antd';
import Toast from './../Toast/Toast'
import Button from './../Button/Button';
import 'antd/dist/antd.css';

export default class UploadButton extends Component{
    constructor(props) {
        super(props);
        this.state = { 
            config:{
                name: 'file',
                buttonText:'点击上传',
                buttonFontSize: 14,
                buttonHeight: 30,
                action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
                accept: '.gif,.jpg,.png,.jpeg',
                headers: { authorization: 'authorization-text', 'X-XSRF-TOKEN': window.decodeURIComponent( this._getCookie("XSRF-TOKEN") ) || "" },
                fileList: [],
                size: "5",
                toastText: '',
                toastParent: document.body,
                afterUpload(){},
                afterMove(){},
            },
            backupList :{}
        };
    }

    _getCookie = ( name ) => {
        var strcookie = document.cookie;//获取cookie字符串
        var arrcookie = strcookie.split("; ");//分割
        for( var i = 0; i< arrcookie.length; i++){
            var arr = arrcookie[i].split("=");
            if( arr[0] == name ){
                return window.decodeURIComponent(arr[1])
            }
        }
    }
    
    _handleChange = info =>{
        let { config } = this.state;
        let { backupList } = this.state;
        let fileList = [...info.fileList];
        if(info.file.size > parseFloat(config.size)*1024*1024){
            if(config.toastText !== ''){
                console.log(config.toastText)
                Toast({
                    text: '大小超出限制',
                    times: 1500,
                    parent: config.toastParent,
                    position: 'absolute',
                })
            } 
            return false;
        }
        fileList = fileList.splice(-1);
        // info.file.url = null;
        config.fileList = fileList;
        this.setState({ config });

        if (info.file.status !== 'uploading') {

        }
        
        if (info.file.status === 'done') {
            backupList = fileList[0];
            this.setState({ backupList });
            config.afterUpload({
                status:'success',
                file:info.file
            });

        } else if (info.file.status === 'error') {
            if(JSON.stringify(this.state.backupList) !== "{}"){
                try{
                    config.fileList = [];
                    config.fileList.push(this.state.backupList);
                    this.setState({ config });
                }catch(e){}
            }else{
                config.fileList = [];
                this.setState({ config });
            }
            config.afterUpload({
                status:'error',
                file:info.file
            });
        } else if(info.file.status === 'removed'){
            config.afterMove({
                status:'removed',
                file:info.file
            });
            config.fileList = [];
            backupList = {};
            this.setState({ backupList, config });
        }
    }

    _handleMove = info =>{
        let { config } = this.state;
        config.afterMove(info);
    }
    

    componentDidMount(){
        let { config, backupList } = this.state;
        if( !this.props ) return false;
        let newConfig = Object.assign(config,this.props.config);

        if(this.props.config.fileList.length > 0 && this.props.config.fileList[0].name !== ''){
            backupList = this.props.config.fileList[0];
        }else{
            newConfig.fileList = [];
        }// 如果id为空则置空上传列表

        this.setState({
            backupList,
            config:newConfig
        })
    }

    componentWillReceiveProps(next){
        let { config, backupList } = this.state;
        if( !next ) return false;
        let newConfig = Object.assign(config,next.config);

        if(this.props.config.fileList.length > 0 && this.props.config.fileList[0].name !== ''){
            backupList = this.props.config.fileList[0];
        }else{
            newConfig.fileList = [];
        }
        this.setState({
            backupList,
            config:newConfig
        })
    }

    
    render () {
        const _this = this;
        const props = {
            name : _this.state.config.name,
            accept : _this.state.config.accept,
            action: _this.state.config.action,
            headers: _this.state.config.headers,
            onChange: _this._handleChange,
            onRemove: _this._handleMove,
        };// uoload参数集
        return(
            <div className="upload_button_main">
                <Upload {...props} fileList={ this.state.config.fileList }>
                    <Button
                        config={{
                            text : _this.state.config.buttonText,
                            type : 'blue',
                            height : _this.state.config.buttonHeight,
                            fontSize : _this.state.config.buttonFontSize,
                        }}
                    />
                </Upload>
            </div>
        )
    }
    
}